import type { TableSortingState } from '@ibsys/kit';
import type { ColumnDescriptor } from './columnDescriptors';
import type { DescriptionPart, DescriptionValue } from './types';

/** Идентификатор части описания, которой открывается строка отбора */
export const SORTING_PART_ID = 'sorting';

/**
 * Описывает действующую сортировку: колонки в порядке применения, направление — стрелкой.
 * Вводных слов перед названием колонки нет — колонка со стрелкой говорит о порядке сама.
 * `isDefault` — названа сортировка по умолчанию: направление у неё переключается, а снимать нечего.
 * `null` — сортировка ссылается на колонку, которой в таблице нет, и описывать нечего.
 */
export const describeSorting = (
  sorting: TableSortingState,
  isDefault: boolean,
  descriptors: Map<string, ColumnDescriptor>,
): DescriptionPart | null => {
  const values = sorting.reduce<DescriptionValue[]>((acc, { id, desc }) => {
    const descriptor = descriptors.get(id);
    if (descriptor) {
      acc.push({
        text: descriptor.header,
        sorting: { columnId: id, direction: desc ? 'desc' : 'asc', isDefault },
      });
    }
    return acc;
  }, []);

  if (!values.length) return null;

  return {
    id: SORTING_PART_ID,
    kind: 'sorting',
    label: null,
    connector: null,
    values,
    isFoldable: false,
  };
};
